import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { HiOutlineGift } from 'react-icons/hi';
import { useTranslation } from '../hooks/useTranslation';

const MultipleBonusDialog = ({ isOpen, onClose, bonuses, onBonusSelect }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  const handleBonusSelect = (bonus) => {
    onBonusSelect(bonus);
    onClose();
  };

  return (
    <div className="multiple-bonus-overlay">
      <div className="multiple-bonus-dialog">
        <div className="multiple-bonus-header">
          <div className="multiple-bonus-icon">
            <HiOutlineGift size={32} />
          </div>
          <h2>{t('popup.multipleTitle', 'Lütfen Bonus Seç')}</h2>
          <p>{t('popup.multipleSubtitle', 'Bu bonus çoklu bonus, lütfen birini seçiniz')}</p>
          <button className="close-button" onClick={onClose}>
            <IoMdClose size={20} />
          </button>
        </div>
        
        <div className="multiple-bonus-content">
          {bonuses.map((bonus, index) => (
            <React.Fragment key={bonus.process_name}>
              <button
                className="bonus-option-button"
                onClick={() => handleBonusSelect(bonus)}
              >
                {bonus.bonus_name}
              </button>
              {index < bonuses.length - 1 && (
                <div className="bonus-separator">{t('popup.or', 'veya')}</div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MultipleBonusDialog;
